var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#E0EAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 20.5C24.9863 20.5 27 18.4863 27 16C27 13.5137 24.9863 11.5 22.5 11.5C20.0137 11.5 18 13.5137 18 16C18 18.4863 20.0137 20.5 22.5 20.5ZM22.5 22.75C19.4962 22.75 13.5 24.2575 13.5 27.25V29.5H31.5V27.25C31.5 24.2575 25.5038 22.75 22.5 22.75Z",
    fill: "#357AEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b94dbccd1308d006f90c165bfa580602.svg";
export { ForwardRef as ReactComponent };